import React from 'react';
import '../../styles/collaborators/collaborators.css';
import uniLogos from '../../assets/img/collab_uni_logos.png';

const CollaboratorIntro = () => {

	return (
		<section className="collaboratorintro">
				<h2>Collaboration</h2>
				<p>
					This initiative aims to establish a globally competitive precision medicine environment by integrating 
					proteomics—representing molecular phenotype-level data—into clinical diagnostics. We have assembled a core team of 
					clinical proteomics experts from Karolinska Institutet (led by PI Professor Janne Lehtiö), the University of Gothenburg 
					(led by Dr. Carina Sihlbom Wallem), and Lund University (led by Professor Johan Malmström). The team focuses on 
					implementing clinical proteomics across the full pipeline: from method standardization and data analysis to the 
					organization of a national network.
					<br/>
					<br/>
					To provide a clinical implementation testbed, the cancer proteomics strategy has been integrated into the cancer 
					diagnostics framework at Karolinska University Hospital (led by co-PI Professor Mikael Björnstedt, an expert in cancer 
					pathology). In 2022, a clinical proteomics unit—with a physical laboratory within the hospital’s pathology division—was 
					established, with Professor Lehtiö serving as its head (part-time, employed by the university hospital). This unit will 
					serve as a model for similar developments at other participating sites. 
				</p>
				<img
					src={uniLogos}
					alt="Collaborator Logos"
					className="uniLogosImg"
				/>
				<p>
					This project is also endorsed by the Karolinska Comprehensive Cancer Center (KCCC)
					and precision medicine center Karolinska as well as Swedish CCC network, testbed
					Sweden and Noll Vision Cancer. 
					<br/>
				</p>
		</section>
	);
};

export default CollaboratorIntro;